export const FORMA_PAGAMENTO_CREATE = "FORMA_PAGAMENTO_CREATE";
export const FORMA_PAGAMENTO_UPDATE = "FORMA_PAGAMENTO_UPDATE";
export const FORMA_PAGAMENTO_LOAD = "FORMA_PAGAMENTO_LOAD";
export const FORMA_PAGAMENTO_LIST = "FORMA_PAGAMENTO_LIST";
export const FORMA_PAGAMENTO_DEFAULT = "FORMA_PAGAMENTO_DEFAULT";
export const FORMA_PAGAMENTO_BYID = "FORMA_PAGAMENTO_BYID";
export const FORMA_PAGAMENTO_REMOVE = "FORMA_PAGAMENTO_REMOVE";
export const FORMA_PAGAMENTO_ADD = "FORMA_PAGAMENTO_ADD";
